import { render, staticRenderFns } from "./MessageShareCampaigns.vue?vue&type=template&id=81570546&scoped=true&"
import script from "./MessageShareCampaigns.vue?vue&type=script&lang=js&"
export * from "./MessageShareCampaigns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81570546",
  null
  
)

export default component.exports